import { render, staticRenderFns } from "./UpdatedPassword.vue?vue&type=template&id=7297a6ba&scoped=true"
import script from "./UpdatedPassword.vue?vue&type=script&lang=js"
export * from "./UpdatedPassword.vue?vue&type=script&lang=js"
import style0 from "./UpdatedPassword.vue?vue&type=style&index=0&id=7297a6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7297a6ba",
  null
  
)

export default component.exports